import 'custom-event-polyfill';

const emit = (element: HTMLElement, eventName: string, eventData: any = {}) => {
  const evt = new CustomEvent(eventName, {
    detail: eventData
  });
  element.dispatchEvent(evt);
}

export default {
  emit
}

